export default {
    auth: {},
    user: {},
    customers: [],
    apiCallsInProgressCount: 0,
    notifications: [],
    notificationMessages: [],
    alerts: [],
    panel: {},
    contracts: [],
    representatives: [],
    loading: {},
    notificationGroups: [],
    policies: []
};
